import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop } from 'vue-property-decorator';
import { ClassItem } from '@/core/models/class.model';
import { Placeholder } from '@/tools/models/class-builder.models';
import EdClassChangeMainPlaceholderModalComponent from '../ed-class-change-main-placeholder-modal/ed-class-change-main-placeholder-modal.component.vue';

@Component({
  name: 'ed-class-builder-placeholder',
  components: {
    EdClassScheduleHeader: () => import(/* EdClassScheduleHeader */'@/tools/components/class-builder/ed-class-schedule-header/ed-class-schedule-header.component.vue'),
    EdClassBuilderPlaceholderCalendar: () => import(/* EdClassBuilderPlaceholderCalendar */'@/tools/components/class-builder/ed-class-builder-placeholder-calendar/ed-class-builder-placeholder-calendar.component.vue')
  }
})
export default class EdClassBuilderPlaceholderComponent extends Vue {
  @Prop({ default: null }) readonly classDetail: ClassItem;
  @Prop({ default: null }) readonly scheduleDetails: any;
  @Prop({ default: null }) readonly placeholders: Placeholder[];

  @Emit('onBack')
  emitOnBack() {
    return;
  }

  handleZoom(weekday, start, end) {
    this.$EdModal.createModal(EdClassChangeMainPlaceholderModalComponent, {
      weekday: weekday,
      start,
      end,
      scheduleDetails: this.scheduleDetails
    });
  }
}